export function getUnlessExperimentStartedEventPayload(
  experimentName: string,
  variantName: string,
) {
  return {
    'Experiment name': experimentName,
    'Variant name': variantName,
  };
}
